import React from "react";
import { Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

import "./TermsAndConditions.css";


function TermsAndConditions() {

    return (
        <>
            <Header />


            {/* =====================================================
                TERMS & CONDITION HERO
            ===================================================== */}

            <section className="terms-hero">

                <div className="container">

                    <div className="terms-hero-content">

                        <span className="terms-badge">
                            HOMOEOADDA
                        </span>

                        <h1>
                            Terms &amp; Condition
                        </h1>

                        <ol className="breadcrumb">

                            <li className="breadcrumb-item">
                                <Link to="/">
                                    Home
                                </Link>
                            </li>

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                Terms &amp; Condition
                            </li>

                        </ol>

                    </div>

                </div>

            </section>


            {/* =====================================================
                TERMS & CONDITION CONTENT
            ===================================================== */}

            <section className="terms-content-section">

                <div className="container">

                    <div className="terms-content-card">


                        {/* =================================================
                            TERMS & CONDITION
                        ================================================= */}

                        <div className="terms-section">

                            <h2 className="section-heading-center">
                                Terms &amp; Condition
                            </h2>

                            <p>
                                The terms “We” / “Us” / “Our”/”Company”
                                individually and collectively refer to{" "}
                                <b>Homoeoadda</b> and the terms “Visitor”
                                ”User” refer to the users.
                            </p>

                            <p>
                                This page states the Terms and Conditions
                                under which you (Visitor) may visit this
                                website (“Homoeoadda.in”). Please read this
                                page carefully. If you do not accept the
                                Terms and Conditions stated here, we would
                                request you to exit this site. The business,
                                any of its business divisions and / or its
                                subsidiaries, associate companies or
                                subsidiaries to subsidiaries or such other
                                investment companies (in India or abroad)
                                reserve their respective rights to revise
                                these Terms and Conditions at any time by
                                updating this posting. You should visit this
                                page periodically to re-appraise yourself of
                                the Terms and Conditions, because they are
                                binding on all users of this Website.
                            </p>

                        </div>


                        {/* =================================================
                            USE OF CONTENT
                        ================================================= */}

                        <div className="terms-section">

                            <h2 className="section-heading-center">
                                USE OF CONTENT
                            </h2>

                            <p>
                                All logos, brands, marks headings, labels,
                                names, signatures, numerals, shapes or any
                                combinations thereof, appearing in this site,
                                except as otherwise noted, are properties
                                either owned, or used under licence, by the
                                business and / or its associate entities who
                                feature on this Website. The use of these
                                properties or any other content on this site,
                                except as provided in these terms and
                                conditions or in the site content, is
                                strictly prohibited.
                            </p>

                            <p>
                                You may not sell or modify the content of
                                this Website or reproduce, display, publicly
                                perform, distribute, or otherwise use the
                                materials in any way for any public or
                                commercial purpose without the respective
                                organisation’s or entity’s written
                                permission.
                            </p>

                        </div>


                        {/* =================================================
                            ACCEPTABLE WEBSITE USE
                        ================================================= */}

                        <div className="terms-section">

                            <h2 className="section-heading-center">
                                ACCEPTABLE WEBSITE USE
                            </h2>


                            <h4>
                                <b>(A) Security Rules</b>
                            </h4>

                            <p>
                                Visitors are prohibited from violating or
                                attempting to violate the security of the Web
                                site, including, without limitation, (1)
                                accessing data not intended for such user or
                                logging into a server or account which the
                                user is not authorised to access, (2)
                                attempting to probe, scan or test the
                                vulnerability of a system or network or to
                                breach security or authentication measures
                                without proper authorisation, (3) attempting
                                to interfere with service to any user, host
                                or network, including, without limitation,
                                via means of submitting a virus or “Trojan
                                horse” to the Website, overloading,
                                “flooding”, “mail bombing” or “crashing”, or
                                (4) sending unsolicited electronic mail,
                                including promotions and/or advertising of
                                products or services. Violations of system or
                                network security may result in civil or
                                criminal liability. The business and / or its
                                associate entities will have the right to
                                investigate occurrences that they suspect as
                                involving such violations and will have the
                                right to involve, and cooperate with, law
                                enforcement authorities in prosecuting users
                                who are involved in such violations.
                            </p>


                            <h4>
                                <b>(B) General Rules</b>
                            </h4>

                            <p>
                                Visitors may not use the Web Site in order to
                                transmit, distribute, store or destroy
                                material (a) that could constitute or
                                encourage conduct that would be considered a
                                criminal offence or violate any applicable
                                law or regulation, (b) in a manner that will
                                infringe the strcmpright, trademark, trade
                                secret or other intellectual property rights
                                of others or violate the privacy or publicity
                                of other personal rights of others, or (c)
                                that is libellous, defamatory, pornographic,
                                profane, obscene, threatening, abusive or
                                hateful.
                            </p>

                        </div>


                        {/* =================================================
                            INDEMNITY
                        ================================================= */}

                        <div className="terms-section">

                            <h2 className="section-heading-center">
                                INDEMNITY
                            </h2>

                            <p>
                                The User unilaterally agree to indemnify and
                                hold harmless, without objection, the Company,
                                its officers, directors, employees and agents
                                from and against any claims, actions and/or
                                demands and/or liabilities and/or losses
                                and/or damages whatsoever arising from or
                                resulting from their use of Homoeokul.com or
                                their breach of the terms .
                            </p>

                        </div>


                        {/* =================================================
                            LIABILITY
                        ================================================= */}

                        <div className="terms-section">

                            <h2 className="section-heading-center">
                                LIABILITY
                            </h2>

                            <p>
                                User agrees that neither Company nor its group
                                companies, directors, officers or employee
                                shall be liable for any direct or/and indirect
                                or/and incidental or/and special or/and
                                consequential or/and exemplary damages,
                                resulting from the use or/and the inability to
                                use the service or/and for cost of procurement
                                of substitute goods or/and services or
                                resulting from any goods or/and data or/and
                                information or/and services purchased or/and
                                obtained or/and messages received or/and
                                transactions entered into through or/and from
                                the service or/and resulting from unauthorized
                                access to or/and alteration of user’s
                                transmissions or/and data or/and arising from
                                any other matter relating to the service,
                                including but not limited to, damages for
                                loss of profits or/and use or/and data or
                                other intangible, even if Company has been
                                advised of the possibility of such damages.
                            </p>

                            <p>
                                User further agrees that Company shall not be
                                liable for any damages arising from
                                interruption, suspension or termination of
                                service, including but not limited to direct
                                or/and indirect or/and incidental or/and
                                special consequential or/and exemplary
                                damages, whether such interruption or/and
                                suspension or/and termination was justified or
                                not, negligent or intentional, inadvertent or
                                advertent.
                            </p>

                            <p>
                                User agrees that Company shall not be
                                responsible or liable to user, or anyone, for
                                the statements or conduct of any third party
                                of the service. In sum, in no event shall
                                Company’s total liability to the User for all
                                damages or/and losses or/and causes of action
                                exceed the amount paid by the User to Company,
                                if any, that is related to the cause of
                                action.
                            </p>

                        </div>


                        {/* =================================================
                            DISCLAIMER OF CONSEQUENTIAL DAMAGES
                        ================================================= */}

                        <div className="terms-section">

                            <h2 className="section-heading-center">
                                DISCLAIMER OF CONSEQUENTIAL DAMAGES
                            </h2>

                            <p>
                                In no event shall Company or any parties,
                                organizations or entities associated with the
                                corporate brand name us or otherwise,
                                mentioned at this Website be liable for any
                                damages whatsoever (including, without
                                limitations, incidental and consequential
                                damages, lost profits, or damage to computer
                                hardware or loss of data information or
                                business interruption) resulting from the use
                                or inability to use the Website and the
                                Website material, whether based on warranty,
                                contract, tort, or any other legal theory, and
                                whether or not, such organization or entities
                                were advised of the possibility of such
                                damages.
                            </p>

                        </div>


                        {/* =================================================
                            DISCLAIMER
                        ================================================= */}

                        <div className="terms-section">

                            <h2 className="section-heading-center">
                                Disclaimer
                            </h2>

                            <p>
                                Thanks for taking the time to understand hard
                                yet necessary disclaimer policies which comes
                                with our new friendship.Please read these
                                carefully. By befriending or exploring me i.e
                                Homoeoadda, you’re agreeing to these Terms.
                                This is a legal agreement.
                            </p>

                            <p>
                                You agree that your use of the Homoeoadda
                                website shall be at your sole risk. To the
                                fullest extent permitted by law, Homoeoadda ,
                                its founders, officers, directors, employees,
                                and agents disclaim all warranties, express
                                or implied, in connection with the website
                                and your use thereof.
                            </p>

                        </div>


                        {/* =================================================
                            WARRANTIES AND LIABILITIES
                        ================================================= */}

                        <div className="terms-section">

                            <h2 className="section-heading-center">
                                Warranties and Liabilities
                            </h2>

                            <p>
                                <b>Homoeoadda</b> makes no warranties or
                                representations about the accuracy or
                                completeness of this site’s content or the
                                content of any sites linked to this site and
                                assumes no liability or responsibility for
                                any:
                            </p>

                            <div className="terms-numbered-list">

                                <p>
                                    <b>1.</b> Errors, mistakes, or inaccuracies
                                    of content.
                                </p>

                                <p>
                                    <b>2.</b> Personal injury or property
                                    damage, of any nature whatsoever,
                                    resulting from your access to and use of
                                    our website
                                </p>

                                <p>
                                    <b>3.</b> Any unauthorized access to or
                                    use of our secure servers and/or any and
                                    all personal information and/or financial
                                    information stored therein
                                </p>

                                <p>
                                    <b>4.</b> Any interruption or cessation of
                                    transmission to or from our website
                                </p>

                                <p>
                                    <b>5.</b> Any bugs, viruses, trojan horses,
                                    or the like which may be transmitted to or
                                    through our website by any third party
                                </p>

                                <p>
                                    <b>6.</b> Any errors or omissions in any
                                    content or for any loss or damage of any
                                    kind incurred as a result of the use of
                                    any content posted, emailed, transmitted,
                                    or otherwise made available via the
                                    Homoeoadda website.
                                </p>

                            </div>


                            <p>
                                Homoeoadda does not warrant, endorse,
                                guarantee, or assume responsibility for any
                                product or service advertised or offered by a
                                third party or users of Homoeoadda through the
                                Homoeoadda website or any hyperlinked website
                                or featured in any banner or other advertising,
                                and Homoeoadda will not be a party to or in any
                                way be responsible for monitoring any
                                transaction between you and third-party
                                providers of products or services. As with the
                                purchase of a product or service through any
                                medium or in any environment, you should use
                                your best judgment and exercise caution where
                                appropriate.
                            </p>


                            <p>
                                Homoeoadda also does not warrant, endorse,
                                guarantee, or take responsibility to get you
                                into the college you aspire.
                                Some states or other jurisdictions do not
                                allow the exclusion of implied warranties, so
                                the above exclusions may not apply to you. You
                                may also have other rights that vary from state
                                to state and jurisdiction to jurisdiction.
                            </p>

                        </div>

                    </div>

                </div>

            </section>


            <Footer />

        </>
    );
}


export default TermsAndConditions;